import { Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import StyledBox from "../styled/styledBox";
import React from "react";

const WelcomeStepOne = (): React.JSX.Element => (
  <StyledBox>
    <Typography variant="h5" color="initial" sx={{ mb: 2, fontWeight: "bold" }}>
      Schritt 1.
    </Typography>

    <Typography
      variant="body1"
      color="primary"
      sx={{ mb: 2, fontWeight: "bold" }}
    >
      Vor der Buchung editierbare Dateien hochladen.
    </Typography>

    <Typography variant="body1" color="initial" sx={{ mb: 2 }}>
      Stelle zumindest deinen aktuellen Lebenslauf als Worddokument (<b>.doc</b>
      ) zur Verfügung
    </Typography>

    <Link
      to={"/files"}
      style={{
        textAlign: "center",
        width: "100%",
      }}
    >
      <Button fullWidth variant="contained" color="secondary">
        Meine Unterlagen
      </Button>
    </Link>
  </StyledBox>
);

export default WelcomeStepOne;
